import { AVAILABLE_TESTS } from "../helpers/constants";

export interface TestTypeConfig {
  code: string;
  name: string;
  category: 'competency' | 'disc' | 'bounded-disc' | 'unified';
  instructions: {
    default: string;
    bounded?: string;
  };
  rendering: {
    showProgress: boolean;
    showTimer: boolean;
    allowNavigation: boolean;
    requiresSpecialHandling: boolean;
    showInInvitation: boolean;
  };
  validation: {
    minQuestions: number;
    maxAttempts: number;
    timeLimit?: number;
  };
  acceptingInvitations: boolean;
}

export interface TestTypeRegistry {
  [testCode: string]: TestTypeConfig;
}

export const TEST_TYPE_REGISTRY: TestTypeRegistry = {
  TestCompetences: {
    code: 'TestCompetences',
    name: 'Test Growme (descontinuado)',
    category: 'competency',
    instructions: {
      default: 'Lee detenidamente cada situación y selecciona la alternativa que mejor represente cómo actuarías en un contexto laboral similar.',
    },
    rendering: {
      showProgress: true,
      showTimer: true,
      allowNavigation: false,
      requiresSpecialHandling: false,
      showInInvitation: true,
    },
    validation: {
      minQuestions: 10,
      maxAttempts: 1,
      timeLimit: 3600,
    },
    acceptingInvitations: false,
  },
  TestDisc: {
    code: 'TestDisc',
    name: 'Test DISC (descontinuado)',
    category: 'disc',
    instructions: {
      default: '¡Te damos la bienvenida al Test DISC de Growme! A través de este test, obtendrás información valiosa sobre cómo te percibes en diferentes ámbitos de tu vida.',
    },
    rendering: {
      showProgress: true,
      showTimer: false,
      allowNavigation: true,
      requiresSpecialHandling: false,
      showInInvitation: true,
    },
    validation: {
      minQuestions: 28,
      maxAttempts: 1,
    },
    acceptingInvitations: false,
  },
  TestDiscAcotado: {
    code: 'TestDiscAcotado',
    name: 'Test DISC Acotado bli',
    category: 'bounded-disc',
    instructions: {
      default: '¡Bienvenido (a) al Test Growme! Este test ha sido diseñado para proporcionarte información valiosa sobre cómo te percibes y cómo actúas en distintos contextos laborales.',
      bounded: '¡Bienvenido (a) al Test Growme! Este test ha sido diseñado para proporcionarte información valiosa sobre cómo te percibes y cómo actúas en distintos contextos laborales.',
    },
    rendering: {
      showProgress: false,
      showTimer: false,
      allowNavigation: false,
      requiresSpecialHandling: true,
      showInInvitation: false,
    },
    validation: {
      minQuestions: 24,
      maxAttempts: 1,
    },
    acceptingInvitations: false,
  },
  TestCompetencesComplete: {
    code: 'TestCompetencesComplete',
    name: 'Test Growme',
    category: 'unified',
    instructions: {
      default: '¡Bienvenido al Test GrowMe Completo! Este test evalúa tanto tu perfil DISC como tus competencias profesionales en una sola sesión.',
    },
    rendering: {
      showProgress: true,
      showTimer: true,
      allowNavigation: false,
      requiresSpecialHandling: false,
      showInInvitation: true,
    },
    validation: { // TODO it seems is not being used, it should be removed
      minQuestions: 1,
      maxAttempts: 1,
      timeLimit: 4320,
    },
    acceptingInvitations: true,
  },
};

export class TestTypeService {
  static getTestConfig(testCode: string): TestTypeConfig | null {
    return TEST_TYPE_REGISTRY[testCode] || null;
  }

  static getTestConfigByTest(test: { testId?: string; id?: string } | null | undefined): TestTypeConfig | null {
    if (!test) return null;
    const testId = test.testId || test.id;
    const testFound = AVAILABLE_TESTS.find((availableTest: any) => availableTest.id === testId);
    return testFound ? this.getTestConfig(testFound.code) : null;
  }

  static isTestCategory(test: { testId?: string; id?: string } | null | undefined, category: string): boolean {
    const config = this.getTestConfigByTest(test);
    return config?.category === category;
  }

  static getTestInstructions(test: { testId?: string; id?: string } | null | undefined, variant?: string): string {
    const config = this.getTestConfigByTest(test);
    if (!config) return '';
    return (variant && (config.instructions as any)[variant])
      ? (config.instructions as any)[variant]
      : config.instructions.default;
  }

  static shouldShowProgress(test: { testId?: string; id?: string } | null | undefined): boolean {
    const config = this.getTestConfigByTest(test);
    return config?.rendering.showProgress ?? false;
  }

  static requiresSpecialHandling(test: { testId?: string; id?: string } | null | undefined): boolean {
    const config = this.getTestConfigByTest(test);
    return config?.rendering.requiresSpecialHandling ?? false;
  }
}
